var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgRollbackIcon = ({
  title,
  titleId,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 14,
  height: 16,
  fill: "none",
  viewBox: "0 0 14 16",
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#49475A",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.7,
  d: "M10.333.667 13 3.333m0 0L10.333 6M13 3.333H3.667A2.667 2.667 0 0 0 1 6v1.333m2.667 8L1 12.667m0 0L3.667 10M1 12.667h9.333A2.667 2.667 0 0 0 13 10V8.667"
})));
export { SvgRollbackIcon as ReactComponent };
export default __webpack_public_path__ + "assets/images/rollbackIcon.svg";